const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        component: () => import('pages/IndexPage.vue'),
      },
      {
        path: 'trading-coins',
        component: () => import('pages/TradingCoins.vue'),
      },
    ],
  },
  {
    path: '/coins',
    component: () => import('layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'coins-home',
        component: () => import('pages/coins/CoinsPage.vue'),
      },
      {
        path: 'top10',
        name: 'coins-top10',
        component: () => import('pages/coins/Top10Page.vue'),
      },
      {
        path: 'longterm',
        name: 'coins-longterm',
        component: () => import('pages/coins/LongtermPage.vue'),
      },
      {
        path: 'emergency',
        name: 'coins-emergency',
        component: () => import('pages/coins/EmergenciesPage.vue'),
      },
      {
        path: 'offline',
        name: 'coins-offline',
        component: () => import('pages/coins/OfflinePage.vue'),
      },
      {
        path: ':id',
        name: 'coin-details',
        component: () => import('pages/coins/CoinDetailsPage.vue'),
      },
    ],
  },
  {
    path: '/orders',
    component: () => import('layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'orders-main',
        component: () => import('src/pages/orders/OrdersPage.vue'),
      },
      {
        path: 'all',
        name: 'orders-all',
        component: () => import('src/pages/orders/AllOrdersPage.vue'),
      },
    ],
  },
  {
    path: '/predictions',
    component: () => import('layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'success',
        name: 'success',
        component: () => import('src/pages/predictions/PredictionsSuccessPage.vue'),
      },
      {
        path: 'failed',
        name: 'failed',
        component: () => import('src/pages/predictions/PredictionsFailedPage.vue'),
      },
      {
        path: 'pending',
        name: 'pending',
        component: () => import('src/pages/predictions/PredictionsPendingPage.vue'),
      },
      {
        path: 'good',
        name: 'good',
        component: () => import('src/pages/predictions/PredictionsGoodPage.vue'),
      },
      {
        path: 'multi',
        name: 'multi',
        component: () => import('src/pages/predictions/PredictionsMultiPage.vue'),
      },
    ],
  },
  {
    path: '/backtest',
    component: () => import('layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'outstanding',
        name: 'outstanding',
        component: () => import('src/pages/backtest/outstanding.vue'),
      },
      {
        path: 'momentum/:period_in_days',
        name: 'backtest-momentum',
        component: () => import('src/pages/backtest/momentum.vue'),
      },
      {
        path: 'all/:period_in_days',
        name: 'backtest-all',
        component: () => import('src/pages/backtest/all.vue'),
      },
      {
        path: 'trend/:period_in_days',
        name: 'backtest-trend',
        component: () => import('src/pages/backtest/trend.vue'),
      },
      {
        path: 'volume/:period_in_days',
        name: 'backtest-volume',
        component: () => import('src/pages/backtest/volume.vue'),
      },
      {
        path: 'bullish/:period_in_days',
        name: 'backtest-bullish',
        component: () => import('src/pages/backtest/bullish.vue'),
      },
      {
        path: 'test/:period_in_days',
        name: 'backtest-test',
        component: () => import('src/pages/backtest/test.vue'),
      },
      {
        path: 'rsi/:period_in_days',
        name: 'backtest-rsi',
        component: () => import('src/pages/backtest/rsi.vue'),
      },
      {
        path: 'day-trading',
        name: 'backtest-daytrading',
        component: () => import('src/pages/backtest/tradeok.vue'),
      },
    ],
  },
  {
    path: '/quick-wins',
    component: () => import('layouts/MainLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'coins/:period_in_days',
        name: 'coins',
        component: () => import('src/pages/quick_wins/coins.vue'),
      },
      {
        path: '12-hour/:period_in_days',
        name: 'coins-12hours',
        component: () => import('src/pages/quick_wins/12hour.vue'),
      },
      {
        path: '24-hour/:period_in_days',
        name: 'coins-24hours',
        component: () => import('src/pages/quick_wins/24hour.vue'),
      },
      {
        path: 'all-transactions/:period_in_days',
        name: 'coins-all-transactions',
        component: () => import('src/pages/quick_wins/alltransactions.vue'),
      },
    ],
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/auth',
    component: () => import('layouts/AuthLayout.vue'),
    children: [
      {
        path: 'login',
        component: () => import('pages/AuthLogin.vue'),
      },
    ],
  },
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
]

export default routes
